<smart-cart-form-token-section [token]="usageToken"></smart-cart-form-token-section>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Labels</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card__content">
      <div class="field">
        <span class="field__label">Single Item Label</span>
        <pdq-input
          [formControl]="formGroup.controls.singleItemLabel"
          [placeholder]="'Subtotal ({item_count} item)'"></pdq-input>
        <span class="field__hint">Dynamic field available - {{ '{item_count}' }}</span>
      </div>
      <div class="field">
        <span class="field__label">Multiple Item Label</span>
        <pdq-input
          [formControl]="formGroup.controls.multipleItemLabel"
          [placeholder]="'Subtotal ({item_count} items)'"></pdq-input>
        <span class="field__hint">Dynamic field available - {{ '{item_count}' }}</span>
      </div>
    </div>
  </div>
</pdq-card>

<smart-cart-form-custom-code
  [enabledControl]="formGroup.controls.customCode.controls.enabled"
  [codeControl]="formGroup.controls.customCode.controls.code"
  [defaultCode]="starterTemplate"
  [variables]="customCodeVariables"></smart-cart-form-custom-code>
